/*
##################
## BlockWrapper ##
##################
Wrapper to hidde or show groups of fields.

* OPTIONS
    * position[Number]: Position (hierarchy) of the blocks. Required.
    * visible[Boolean]: Hide or show. Default: false. Not required.
    * firstValue[String]: It's necessary for to show the hidden blocks when these have a data. Not required.

* EXAMPLE
<BlockWrapper
    position={1}
    visible={false}
    firstValue={userProfile.selfEmployed_selfActivity}
>
	<div>
		<h1>Content</h1>
	</div>
</BlockWrapper>
*/
const React = require('react');
const PropTypes = require('prop-types');

class BlockWrapper extends React.Component {
    constructor(props) {
        super(props);
        this.onKeyUp = this.onKeyUp.bind(this);
        this.showBlock = this.showBlock.bind(this);
    }

    componentDidMount() {
        const { position, cancelDefaultFocusBehavior, shouldKeepVisibleAfter } = this.props;
        const elementId = `blockwrapper_${position}`;
        const element = document.getElementById(elementId).lastChild;
        let elementClass = element.getElementsByTagName('input');
        if (elementClass.length === 0) {
            elementClass = element.getElementsByClassName('Select');
        }

        for (let i = 0, len = elementClass.length; i < len; i++) {
            if (!cancelDefaultFocusBehavior) {
                elementClass[i].addEventListener('click', this.showBlock, false);
                elementClass[i].addEventListener('focus', this.showBlock, false);
                elementClass[i].addEventListener('keyup', this.onKeyUp, false);
            }
        }

        if (shouldKeepVisibleAfter) {
            const wrapperPosition = document.getElementById(`blockwrapper_${position}`);
            if (wrapperPosition) {
                wrapperPosition.style.display = 'block';
            }
        }
    }

    onKeyUp(e) {
        const { position } = this.props;
        const newPos = position + 1;
        const wrapperPosition = document.getElementById(`blockwrapper_${newPos}`);
        if (e.which === 9 && wrapperPosition) {
            wrapperPosition.style.display = 'block';

            return;
        }
    }

    showBlock() {
        const { position } = this.props;
        const wrapperPosition = document.getElementById(`blockwrapper_${position + 1}`);
        if (wrapperPosition) {
            wrapperPosition.style.display = 'block';
        }
    }

    render() {
        const { visible, position, firstValue, shouldKeepVisibleAfter } = this.props;
        const elementId = `blockwrapper_${position}`;
        let showBlock = visible;
        if (firstValue || shouldKeepVisibleAfter) {
            showBlock = true;
        }
        const styles = {
            display: showBlock ? 'block' : 'none',
        };

        return (
            <fieldset className="block-wrapper" id={elementId} style={styles}>
                {this.props.children}
            </fieldset>
        );
    }
}

React.propTypes = {
    visible: PropTypes.bool,
    position: PropTypes.number,
    firstValue: PropTypes.string,
    cancelDefaultFocusBehavior: PropTypes.bool,
};

React.defaultProps = {
    visible: false,
    firstValue: '',
    cancelDefaultFocusBehavior: false,
};

module.exports = BlockWrapper;
